//Date Pipe to show "EDT"/"EST" at the end of date
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'DateET',
    standalone: true
})
export class DateETPipe  implements PipeTransform {
    constructor (private datePipe: DatePipe ) {}

    transform(value: Date | string | number, format?: string, timezone?: string, locale?: string): string | null {
        const formattedDate = this.datePipe.transform(value, format, timezone, locale);
        const last3 = value?.toString().slice(-3);

        if (formattedDate && last3 === 'EDT' || last3 === 'EST') {
            return formattedDate + ' ' + last3;
        }
        
        return formattedDate;
    }
}